module.exports = "/_next/static/images/d1c11f5f3e29161183ab4b7d25323b6d-plus.svg.webp";